import {addEventMeal, deleteEventMeal, updateEventMeal} from "../Meals/BrowserDatabaseFunctions";


export const E_addEventMealResults = async (_incoming) => {
    console.log("E_addNewMealResults");

    try {
        if (_incoming?.result !== "ok") {
            console.log("Add result not ok");
            return null;
        }

        const eventId = _incoming.event_id;
        const newMeal = _incoming.meal; // should already contain { id, temp_id?, ... }

        if (!eventId || !newMeal) {
            console.error("Missing event_id or meal in payload");
            return null;
        }

        // Persist to browser DB (best-effort)
        try {
            await addEventMeal(eventId, newMeal);
            console.log("Meal added successfully");
        } catch (error) {
            console.error("Error adding Meal to Browser database: ", error);
        }

        return null;

    } catch (e) {
        console.log("ERROR:", e);
        return null;
    }
};

export const E_updateEventMealResults = async (_incoming) => {
    console.log("E_updateEventMealResults : ", _incoming.meal);

    /*
        an Event Meal was updated
     */

    try {
        const _result = _incoming.result;

        if (_result === "ok") {
            try {
                await updateEventMeal(_incoming.event_id, _incoming.meal);
                console.log("Meal updated successfully");
            } catch (error) {
                console.error("Error updating Meal: ", error);
            }

            return null; // Return the updated meal regardless of success or failure

        } else {
            console.log("Update result not ok");
            return null; // Return null if the result is not ok
        }

    } catch (e) {
        console.log("ERROROROR : " + e);
        return null; // Return null if there was a top-level error
    }
}

export const E_deleteEventMealResults = async (_incoming) => {
    console.log("E_deleteEventMealResults");

    /*
        an Event Meal was deleted
     */


    try {

        const _result = _incoming.result;

        if (_result === "ok") {

            try {
                await deleteEventMeal(_incoming.event_id, _incoming.meal_id);
                console.log("Meal deleted successfully");
            } catch (error) {
                console.error("Error deleting Meal: ", error);
            }

        }
    } catch (e){
        console.log("ERROROROR : "+e);
    }

}